export const DEFAULT_FETCHING_STATE = {state: false};

export const DEFAULT_NO_ERROR = { timestamp: 0, message: '' };